import React from "react";
import NotificationsIconRenderer from "./NotificationsIconRenderer";
import CloseButton from "../../../components/Common/CloseButton";
import moment from "moment-timezone";

const NotificationCard = ({
  isFetching,
  delete: deleteFunction,
  notification: { id, title, message, status, timestamp, read },
  handleNotificationClick,
  canDelete = true,
  canMarkRead = true,
}) => {
  const handleCardClick = () => {
    if (!canMarkRead || isFetching) return;
    handleNotificationClick(id, !read || read === "no");
  };
  const handleDelete = (e) => {
    if (!canDelete || isFetching) return;
    e.stopPropagation();
    deleteFunction(id, !read);
  };

  return (
    <div
      className={
        "notificationCard " +
        (!read || read === "no" ? "unread" : "") +
        (" " + status?.toLowerCase())
      }
      onClick={handleCardClick}
      style={{ cursor: canMarkRead ? "pointer" : "default" }}
    >
      <div className="icon">
        <NotificationsIconRenderer name={status?.toLowerCase()} />
      </div>
      <div className="detail w-100">
        <h2 className="notification-title d-flex justify-content-between align-items-start gap-2 text-darkN">
          <span>{title}</span>
          {canDelete && !isFetching && (
            <CloseButton
              theme="light"
              color="red"
              height={12}
              onClick={handleDelete}
            />
          )}
        </h2>
        <p className="notification-message">{message}</p>
        <p className="notification-time">
          {timestamp ? moment(timestamp).format("DD-MM-YYYY HH:mm:ss") : ""}
        </p>
      </div>
    </div>
  );
};

export default NotificationCard;
